
const BASE_URL = 'https://api-auth-admin.wellbeingplus.in';
const DIRECT_BASE_URL = 'https://api-lb.emoneeds.com';
const API_ADMIN_PORT = ``;
const API_AUTH_PORT = ``;
const API_USER_PORT = ``;
const API_REGISTRATION_PORT = ``;
const API_APPOINTMENT_PORT = ``;
const API_SESSION_PORT = ``;
const API_REPORTS_PORT = ``;
const API_CRM_PORT = ``;
const API_WEBSOCKET_PORT = ``;

//local baseurl
// const AUTH_BASE_URL = 'http://localhost:9002';
// const USER_BASE_URL = 'http://localhost:9003';
// const ADMIN_BASE_URL = 'http://localhost:9001';
// const REGISTRATION_BASE_URL = 'http://localhost:9004';
// const APPOINTMENT_BASE_URL = 'http://localhost:9006';
// const ASSESSMENT_BASE_URL = 'http://localhost:9008';
// const REPORT_BASE_URL = 'http://localhost:9010';
// const CORE_ENGINE_V2_BASE_URL = 'http://localhost:12001';

const AUTH_BASE_URL = 'https://api-auth-dev.wellbeingplus.in';
const USER_BASE_URL = 'https://api-users-dev.wellbeingplus.in';
const ADMIN_BASE_URL = 'https://api-admin-dev.wellbeingplus.in';
const REGISTRATION_BASE_URL = 'https://api-registration-dev.wellbeingplus.in';
const APPOINTMENT_BASE_URL = 'https://api-appointment-dev.wellbeingplus.in';
const ASSESSMENT_BASE_URL = 'https://api-assessment-dev.wellbeingplus.in';
const REPORT_BASE_URL = 'https://api-report-dev.wellbeingplus.in';
const CORE_ENGINE_V2_BASE_URL = 'https://api-v2-core.emoneeds.com';

export const environment = {
  production: false,
  defaultLanguage: 'en',
  supportedLanguages: [
    { id: 'en', name: 'English', regional: 'English' },
  ],
  CORPORATE_BASE_URL: 'https://corporate.wellbeingplus.in/auth/verify-meeting-link/',

  //auth
  auth_prefix_url: `${AUTH_BASE_URL}/api/v1/auth`,

  //user
  user_prefix_url: `${USER_BASE_URL}/api/v1/user`,

  //admin
  admin_prefix_url: `${ADMIN_BASE_URL}/api/v1/admin`,
  admin_prefix_url_v2: `${ADMIN_BASE_URL}/api/v2/admin`,
  admin_prefix_url_v2_direct: `${ADMIN_BASE_URL}/api/v2/admin`,
  admin_prefix_direct_url: `${ADMIN_BASE_URL}/api/v1/admin`,

  //registration
  patient_registration_prefix_url: `${REGISTRATION_BASE_URL}/api/v1/registration`,
  beneficiary_registration_prefix_url: `${REGISTRATION_BASE_URL}/api/v1/registration`,
  registration_url_v2_cdn: `${REGISTRATION_BASE_URL}/api/v2/registration`,

  //appointment
  appointment_url: `${APPOINTMENT_BASE_URL}/api/v1/appointment`,

  //assessment
  patient_assessment_prefix_url: `${ASSESSMENT_BASE_URL}/api/v1/assessment/patientAssessment/`,

  // reports
  report_prefix_direct_url: `${REPORT_BASE_URL}/api/v1/reports`,
  report_prefix_url: `${REPORT_BASE_URL}/api/v1/reports`,
  report_prefix_urlv2: `${REPORT_BASE_URL}/api/v2/reports`,

  // v2 core-engine url
  core_engine_v2_url: `${CORE_ENGINE_V2_BASE_URL}/api/v1/core`,

  ASSESSMENT_DOMAIN_URL: 'https://dev-scanpsy.wellbeingplus.in/',
  BASE_URL: `${BASE_URL}/api/v1`,
  admin_prefix_url_port: `${DIRECT_BASE_URL}${API_ADMIN_PORT}`,
  socket_admin_prefix_url_port: `${BASE_URL}:9001`,
  session_prefix_url_port: `${BASE_URL}:9005`,
  crm_prefix_url: `${DIRECT_BASE_URL}${API_CRM_PORT}/api/v1/crm`,
  crm_prefix_direct_url: `${BASE_URL}${API_CRM_PORT}/api/v1/crm`,
  session_prefix_url: `${BASE_URL}${API_SESSION_PORT}/api/v1/session`,
  session_prefix_direct_url: `${DIRECT_BASE_URL}${API_SESSION_PORT}/api/v1/session`,
  recaptcha_site_key: '6LdNBNUZAAAAAAYITU9accPJNhMSzHMsuqc99RPE',
  finance_prefix_url: `${DIRECT_BASE_URL}${API_REPORTS_PORT}/api/v1/finance`,
  safevac_oauth_sso_uri: `https://safevac.nhp.gov.in/service/uaa/oauth/authorize?response_type=code&state=&client_id=cowin_dio&scope=&redirect_uri=${BASE_URL}/beneficiarymanagement`,
  redirect_uri: `${BASE_URL}/beneficiarymanagement`,
  websocket_prefix_direct_url: `${BASE_URL}${API_WEBSOCKET_PORT}`,
  isUat: false,
  chatboturl: 'https://covid19-staging.nhp.gov.in:80/admin/',
  env: 'OtherEnv',
  google_map_api_key: '',


  //Support Grievance
  REPEAT_PER_DAY: {
    1: ['7:00'],
    2: ['7:00', '21:00'],
    3: ['7:00', '12:00', '21:00'],
    4: ['7:00', '12:00', '16:00', '21:00'],
    5: ['7:00', '12:00', '16:00', '18:00', '21:00']
  },
  ROLES: {
    HOSPITAL_ADMINISTRATOR: 'Hospital Administrator',
    ORGANIZATION_ADMINISTARTOR: 'Organization Administrator',
    PSYCHIATRIST: 'Psychiatrist',
    DOCTOR: 'Doctor',
    PSYCHOLOGIST: 'Psychologist',
    RECEPTIONIST: 'Receptionist',
    RPP_COUNSELOR: 'Counsellor',
    CRM_COUNSELOR: 'Counsellor',
    ACCOUNT_MANAGER: 'Account Manager',
    DATA_ANALYST: 'Data Analyst'
  }
};